import { Link, useLocation } from "react-router-dom";
import { Brain } from "lucide-react";
import { useTranslation } from "react-i18next";

export function AIAdvisorFAB() {
  const { pathname } = useLocation();
  const { t } = useTranslation();
  if (pathname.startsWith("/ai") || pathname.startsWith("/settings/ai")) return null;

  return (
    <Link
      to="/ai"
      aria-label={t("ai.fab.open")}
      className="fixed bottom-4 end-4 z-40 group print:hidden pdf-hide flex items-center justify-center h-10 w-10 rounded-full bg-gradient-to-br from-primary to-accent shadow-md shadow-primary/20 opacity-30 hover:opacity-100 hover:scale-110 transition-all duration-300"
      data-pdf-exclude
    >
      <Brain className="h-4 w-4 text-primary-foreground" />
      <span className="absolute end-12 top-1/2 -translate-y-1/2 whitespace-nowrap bg-foreground text-background text-xs px-2.5 py-1 rounded opacity-0 group-hover:opacity-100 transition pointer-events-none">
        {t("ai.fab.label")}
      </span>
    </Link>
  );
}
